import { Component, EventEmitter, Input, Output } from '@angular/core'

import { ScopeComponent } from '@app/features/scoping/models/component.model'
import { UpdateRolePayload, ScopeElementsConfig } from '../models'
import { trackById } from '@app/shared/utils/utils'
import { Role } from '@app/features/scoping/models/role.model'

@Component({ selector: 'scope-roles', templateUrl: './roles.component.html', styleUrls: ['./roles.component.scss'] })
export class RolesComponent {
  @Input() config: ScopeElementsConfig
  @Input() level: number
  @Input() roles: Role[]
  @Input() component: ScopeComponent

  @Output() onOverrideRateCardRoleHours = new EventEmitter<UpdateRolePayload>()
  @Output() onUpdateRole = new EventEmitter<UpdateRolePayload>()

  protected readonly trackById = trackById
}
